import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { App } from "./app";
import { BrowserRouter } from "react-router-dom";
import { Loader } from "@widgets/Loader";
import { LOCAL_STORAGE } from "@shared/constants";

import "./index.scss";

localStorage.removeItem(LOCAL_STORAGE.AccessToken);
localStorage.removeItem(LOCAL_STORAGE.RefreshToken);
localStorage.removeItem(LOCAL_STORAGE.SessionId);
localStorage.removeItem(LOCAL_STORAGE.UserId);
localStorage.removeItem(LOCAL_STORAGE.TelegramId);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Suspense fallback={<Loader />}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Suspense>
  </React.StrictMode>
);
